import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import './index.css';

// Error monitoring — no-op unless VITE_SENTRY_DSN is set at build time (kept separate from the
// server's Sentry project). Errors-only; add tracing/replay later if wanted.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  });
}

// If the app crashes on render, show a minimal recoverable screen (and report it) instead of a blank
// page. Sentry.ErrorBoundary still renders the fallback even when Sentry isn't initialized.
const Fallback = () => (
  <div style={{ maxWidth: 420, margin: '15vh auto', textAlign: 'center', fontFamily: 'system-ui, sans-serif', padding: '0 1rem' }}>
    <h1 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Something went wrong</h1>
    <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
      The page hit an unexpected error. Reloading usually fixes it.
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{ padding: '0.5rem 1rem', borderRadius: 8, border: '1px solid #ccc', background: '#111', color: '#fff', cursor: 'pointer' }}
    >
      Reload
    </button>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
